var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import createCoMallElement from './createCoMallElement';
import { CheckType, checkType, toLine, upperCase, errorMessage, warnMessage, } from './shared';
export var Target;
(function (Target) {
    Target[Target["TO_REACT_ELEMENT_ONLY_SUPPORT_TYPE_AS_STRING"] = 0] = "TO_REACT_ELEMENT_ONLY_SUPPORT_TYPE_AS_STRING";
    Target[Target["TO_REACT_ELEMENT"] = 1] = "TO_REACT_ELEMENT";
    Target[Target["TO_COMALL_ELEMENT"] = 2] = "TO_COMALL_ELEMENT";
})(Target || (Target = {}));
class Render {
    constructor(components = {}) {
        this.components = components;
        this.limit = 3;
        this.count = 0;
    }
    register(key, component) {
        this.components[key] = component;
    }
    workflow(tree, target) {
        this.count = 1;
        if (checkType(tree) !== CheckType.Object) {
            return null;
        }
        if (Target.TO_COMALL_ELEMENT === target) {
            return this.renderCoMallElementByTree(tree);
        }
        return this.renderReactElementByTree(tree, target);
    }
    renderCoMallElementByTree(element) {
        if (this.limit < this.count) {
            warnMessage(`--- 超过了 ${this.limit} 的限制，被忽略`);
            return [];
        }
        if (!Array.isArray(element)) {
            if (checkType(element) === CheckType.String ||
                checkType(element) === CheckType.Number ||
                checkType(element) === CheckType.Undefined ||
                checkType(element) === CheckType.Null) {
                warnMessage('--- 忽略子组件中出现的 String | Number | null | undefined');
                return [];
            }
            let newType = '';
            const { type, props, key } = element;
            const { children, cid } = props, other = __rest(props, ["children", "cid"]);
            const AnyReactType = type;
            if (checkType(type) === CheckType.Function) {
                newType = toLine(AnyReactType.name);
            }
            if (checkType(type) === CheckType.String) {
                newType = toLine(type);
            }
            let compound = Object.assign({}, other);
            if (key) {
                compound['key'] = key;
            }
            return createCoMallElement(newType, compound, ...this.renderCoMallElementByTree(children));
        }
        else {
            this.count++;
            const elements = [];
            for (const childrenElement of element) {
                const newElement = this.renderCoMallElementByTree(childrenElement);
                if (newElement) {
                    elements.push(newElement);
                }
            }
            return elements;
        }
    }
    renderReactElementByTree(element, target) {
        if (this.limit < this.count) {
            warnMessage(`--- 超过了 ${this.limit} 的限制，被忽略`);
            return null;
        }
        if (!Array.isArray(element)) {
            const { type, props, key } = element;
            const { children } = props, other = __rest(props, ["children"]);
            if (checkType(type) === CheckType.String) {
                let compound = Object.assign({}, other);
                if (key) {
                    compound['key'] = key;
                    compound['cid'] = key;
                }
                let component = type;
                if (target === Target.TO_REACT_ELEMENT) {
                    component = this.components[type];
                    if (!component) {
                        errorMessage(`--- 无法从组件注册表中搜索到 key=${type} 的 ${upperCase(type)} 组件`);
                    }
                }
                if (Array.isArray(children)) {
                    return React.createElement(component, compound, this.renderReactElementByTree(children, target));
                }
                return React.createElement(component, compound);
            }
            errorMessage('--- type 的类型必须是 String');
        }
        else {
            this.count++;
            const elements = [];
            for (const children of element) {
                const reactElement = this.renderReactElementByTree(children, target);
                elements.push(reactElement);
            }
            return elements;
        }
        return null;
    }
}
/**
 * taro 的组件规则 view -> View checkbox-group -> CheckboxGroup
 * comall 的组件规则 view -> View  checkbox-group -> CheckboxGroup
 *
 * 通用的规则 view -> View checkbox-group -> CheckboxGroup checkboxGroup - > CheckboxGroup
 */
export class WorkInProgress extends Render {
    constructor(components = {}) {
        super(components);
    }
    registerComponent(key, component) {
        super.register(key, component);
    }
    createRoot(target) {
        return {
            render: (tree) => {
                return super.workflow(tree, target);
            }
        };
    }
}
//# sourceMappingURL=WorkInProgress.js.map